<template>
    <div class="x-field">
        <div class="x-input" :class="{'x-input-error': !!error}">
            <label class="x-label" :class="labelClass" v-if="!!label">{{ label }}
                <slot name="label"></slot>
                <el-tooltip :content="tooltipContent"
                            effect="dark"
                            placement="top-end"
                            v-if="!!tooltipContent">
                    <i class="fa fa-info-circle"></i>
                </el-tooltip>
            </label>
            <div style="display: flex">
                <input v-mask="mask"
                       :value="value"
                       :placeholder="placeholder"
                       class="x-input-mask"
                       @input="updateValue($event.target.value)"
                />
            </div>
            <small v-if="textError !== ''" class="x-label-error" v-text="textError"></small>
        </div>
    </div>
</template>

<script>
import XButtonIcon from "./XButtonIcon.vue"
import {mask} from "vue-the-mask"

export default {
    name: 'XInputMask',
    components: {XButtonIcon},
    directives: {
        mask, // Registra la directiva de vue-the-mask
    },
    props: {
        value: {
            type: String,
            required: true,
        },
        mask: {
            type: [String, Array],
            required: true,
        },
        label: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        error: {
            default: null,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        tooltipContent: {
            type: String,
            default: null,
        },
        textPrepend: {
            type: String,
            default: null,
        },
        labelClass: {
            type: String,
            default: null,
        },
        showButtonNew: {
            type: Boolean,
            default: false
        },
        iconButton: {
            type: String,
            default: 'fal fa-plus',
        }
    },
    data() {
        return {}
    },
    computed: {
        textError() {
            if (!_.isNull(this.error)) {
                return this.error[0]
            }
            return ''
        }
    },
    methods: {
        updateValue(value) {
            this.$emit("input", value)
        },
    }
}
</script>
